import { Button, Col, ControlLabel, Form, FormControl, FormGroup, HelpBlock } from 'react-bootstrap'

import { BUFFER_WELCOME_VIEW } from '../../../constants/saxs'
import PropTypes from 'prop-types'
import React from 'react'

/**
 * React Component used to create or EDIT a buffer.
 */
class SaxsNewOrEditBuffer extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      buffer: this.props.selectedBuffer,
      helpBlockMessages: { acronym: '', comments: '', name: '', ph: '', composition: '', proposal: '' },
      selectedBuffer: this.props.selectedBuffer,
      validationStates: { acronym: null, comments: null, name: null, ph: null, composition: null, proposal: null },
    }

    this.onSaveButtonClicked = this.onSaveButtonClicked.bind(this)
    this.getCurrentBufferFormValidationState = this.getCurrentBufferFormValidationState.bind(this)
    this.setBuffer = this.setBuffer.bind(this)
  }

  render() {
    return (
      <div>
        <h2 className="landing-title"> {this.state.buffer.bufferId === null ? 'New' : 'Edit'} buffer </h2>

        <BufferForm
          activeProposal={this.props.activeProposal}
          helpBlockMessages={this.state.helpBlockMessages}
          buffer={this.state.buffer}
          setBuffer={this.setBuffer}
          validationStates={this.state.validationStates}
        />

        <div style={{ padding: '20px' }}>
          <Button bsStyle="primary" className="pull-right" onClick={this.onSaveButtonClicked}>
            Save
          </Button>
          <Button
            bsStyle="primary"
            className="pull-right"
            style={{ marginRight: '10px' }}
            onClick={() => this.props.setView(BUFFER_WELCOME_VIEW)}
          >
            Cancel
          </Button>
        </div>
      </div>
    )
  }

  getCurrentBufferFormValidationState() {
    const newValidationStates = {
      acronym: null,
      comments: null,
      name: null,
      ph: null,
      composition: null,
      proposal: null,
    }

    const newHelpBlockMessages = {
      acronym: '',
      comments: '',
      name: '',
      ph: '',
      composition: '',
      proposal: '',
    }

    if (this.state.buffer.name === '') {
      newValidationStates.name = 'error'
    }
    if (this.state.buffer.acronym === '') {
      newValidationStates.acronym = 'error'
    }

    return { validationStates: newValidationStates, helpBlockMessages: newHelpBlockMessages }
  }

  onSaveButtonClicked() {
    // check that input values are valid
    const validationStatesAndHelpBlockMessages = this.getCurrentBufferFormValidationState()

    if (
      validationStatesAndHelpBlockMessages.validationStates.acronym !== null ||
      validationStatesAndHelpBlockMessages.validationStates.comments !== null ||
      validationStatesAndHelpBlockMessages.validationStates.name !== null ||
      validationStatesAndHelpBlockMessages.validationStates.ph !== null ||
      validationStatesAndHelpBlockMessages.validationStates.composition !== null ||
      validationStatesAndHelpBlockMessages.validationStates.proposal !== null
    ) {
      // the buffer form is not valid, needs user's feedback
      this.setState({
        validationStates: validationStatesAndHelpBlockMessages.validationStates,
        helpBlockMessages: validationStatesAndHelpBlockMessages.helpBlockMessages,
      })
    } else {
      // the buffer form is valid
      this.props.onSaveButtonClicked({ ...this.state.buffer, proposal: undefined })
    }
  }

  setBuffer(buffer) {
    this.setState({ buffer: buffer })
  }

  componentDidUpdate() {
    if (this.props.selectedBuffer.bufferId !== this.state.selectedBuffer.bufferId) {
      this.setState({ buffer: this.props.selectedBuffer, selectedBuffer: this.props.selectedBuffer })
    }
  }
}

SaxsNewOrEditBuffer.propTypes = {
  /** When provided, it corresponds to the buffer which is edited. As such, it also informs about whether the current component is used
   * to create (buffer is null) or to edit (buffer is not null) */
  buffer: PropTypes.object,
  /** Function triggered when the user clicks on the save button */
  onSaveButtonClicked: PropTypes.func,
}

/**
 * React component which renders the buffer form
 */
class BufferForm extends React.Component {
  constructor(props) {
    super(props)

    this.handleInputChange = this.handleInputChange.bind(this)
  }

  render() {
    return (
      <Form horizontal>
        <FormItem
          disabled
          inputType="text"
          label="Proposal"
          name="proposal"
          onChange={this.handleInputChange}
          value={this.props.activeProposal ? this.props.activeProposal : 'not set'}
          validationState={this.props.validationStates.proposal}
        />

        <FormItem
          helpText=""
          inputType="text"
          label="Name"
          name="name"
          onChange={this.handleInputChange}
          value={this.props.buffer.name}
          validationState={this.props.validationStates.name}
        />

        <FormItem
          helpText={this.props.helpBlockMessages.acronym}
          inputType="text"
          label="Acronym"
          name="acronym"
          onChange={this.handleInputChange}
          value={this.props.buffer.acronym}
          validationState={this.props.validationStates.acronym}
        />

        <FormItem
          helpText=""
          inputType="number"
          label="pH"
          name="ph"
          onChange={this.handleInputChange}
          value={this.props.buffer.ph ? this.props.buffer.ph : ''}
          validationState={this.props.validationStates.ph}
        />

        <FormItem
          inputType="text"
          label="Composition"
          name="composition"
          onChange={this.handleInputChange}
          value={this.props.buffer.composition ? this.props.buffer.composition : ''}
          validationState={this.props.validationStates.composition}
        />

        <FormGroup controlId="comments" validationState={this.props.validationStates.comments}>
          <Col componentClass={ControlLabel} sm={2}>
            Comments
          </Col>
          <Col sm={10}>
            <FormControl
              componentClass="textarea"
              name="comments"
              rows={5}
              value={this.props.buffer.comments ? this.props.buffer.comments : ''}
              onChange={this.handleInputChange}
            />
            <FormControl.Feedback />
          </Col>
        </FormGroup>
      </Form>
    )
  }

  handleInputChange(event) {
    const target = event.target
    const value = target.type === 'checkbox' ? target.checked : target.value
    const name = target.name

    this.props.setBuffer({ ...this.props.buffer, [name]: value })
  }
}

BufferForm.propTypes = {
  /** Function triggered when the user change on of the inputs */
  setBuffer: PropTypes.func,
}

const FormItem = props => (
  <FormGroup validationState={props.validationState} controlId={props.name}>
    <Col componentClass={ControlLabel} sm={2}>
      {props.label}
    </Col>
    <Col sm={10}>
      <FormControl
        disabled={props.disabled === true}
        name={props.name}
        onChange={props.onChange}
        placeholder={props.label}
        type={props.inputType}
        value={props.value}
      />
      <FormControl.Feedback />
      {props.helpText ? <HelpBlock>{props.helpText}</HelpBlock> : null}
    </Col>
  </FormGroup>
)

export default SaxsNewOrEditBuffer

SaxsNewOrEditBuffer.propTypes = {
  /** Proposal name */
  activeProposal: PropTypes.string,
  /** Function triggered when the user clicks the save buffer */
  onSaveButtonClicked: PropTypes.func,
  /** Proposal information including buffers */
  proposalInfo: PropTypes.object,
  /** Buffer selected by the user. Used for edition */
  selectedBuffer: PropTypes.object,
  /** Function used to change the view */
  setView: PropTypes.func,
}
